import {convertUserName} from 'Common/helpers/convertUserName';
import {IServerHorseOwner} from '../types/owner';

export function convertServerHorseOwnerToClient(value: IServerHorseOwner): string {
  return convertUserName(value.firstName, value.lastName);
}
